module.exports = __webpack_public_path__ + "static/1-1d7ba1b8c3cf3100fd2a8610ad08e73a.jpg";